var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings)?_c('div',{class:['flex flex-wrap', _vm.listClass.length ? _vm.listClass : 'mt-2']},_vm._l((_vm.tags),function(item,i){return _c('h6',{key:i,staticClass:"relative mr-4 mb-2 tag-item",class:[_vm.textWhite ? 'text-white' : 'text-truegray-500'],attrs:{"id":'tag-' + item}},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }